import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Check } from "lucide-react";
import LegalLayout from "./legal/LegalLayout";
import { sendContact } from "@/lib/api";

export default function Kontakt() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.name.trim().length < 2 || !form.email.includes("@") || form.message.trim().length < 10) {
      toast.error("Bitte alle Felder vollständig ausfüllen.");
      return;
    }
    setSending(true);
    try {
      await sendContact(form);
      setDone(true);
      toast.success("Ihre Nachricht wurde gesendet.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Senden fehlgeschlagen.");
    } finally {
      setSending(false);
    }
  };

  return (
    <LegalLayout title="Kontakt">
      {done ? (
        <div data-testid="kontakt-success" className="bg-paper rounded-3xl p-10 md:p-14 shadow-card text-center">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-parchment mb-6">
            <Check className="w-6 h-6 text-umber" strokeWidth={1.5} />
          </div>
          <h2 className="font-serif text-3xl text-charcoal mb-4">Ihre Nachricht ist bei uns.</h2>
          <p className="font-serif text-lg text-ink leading-relaxed max-w-md mx-auto">
            Wir melden uns in Ruhe zurück — in der Regel innerhalb eines Werktages.
          </p>
        </div>
      ) : (
        <div className="space-y-8">
          <p className="font-serif text-lg text-ink leading-relaxed">
            Sie erreichen uns über dieses Formular oder direkt per E-Mail an{" "}
            <a href="mailto:hallo@oratiorede.de" className="underline underline-offset-4 text-umber hover:text-charcoal">
              hallo@oratiorede.de
            </a>
            . Wir antworten in der Regel innerhalb eines Werktages.
          </p>

          <form onSubmit={submit} className="bg-paper rounded-3xl p-8 md:p-12 shadow-card space-y-6">
            <div>
              <label className="font-display tracking-[0.25em] text-[10px] uppercase text-umber block mb-3">
                Ihr Name
              </label>
              <input
                type="text"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                data-testid="kontakt-name"
                required
                className="w-full bg-cream rounded-2xl px-5 py-4 font-serif text-lg text-charcoal
                           placeholder:text-ink/50 outline-none focus:ring-2 focus:ring-umber/40"
                placeholder="Ihr vollständiger Name"
              />
            </div>

            <div>
              <label className="font-display tracking-[0.25em] text-[10px] uppercase text-umber block mb-3">
                E-Mail
              </label>
              <input
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                data-testid="kontakt-email"
                required
                className="w-full bg-cream rounded-2xl px-5 py-4 font-serif text-lg text-charcoal
                           placeholder:text-ink/50 outline-none focus:ring-2 focus:ring-umber/40"
                placeholder="ihre@email.de"
              />
            </div>

            <div>
              <label className="font-display tracking-[0.25em] text-[10px] uppercase text-umber block mb-3">
                Ihre Nachricht
              </label>
              <textarea
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                data-testid="kontakt-message"
                required
                rows={6}
                className="w-full bg-cream rounded-2xl px-5 py-4 font-serif text-lg text-charcoal
                           placeholder:text-ink/50 outline-none focus:ring-2 focus:ring-umber/40 resize-none leading-relaxed"
                placeholder="Wie können wir helfen?"
              />
            </div>

            <button
              type="submit"
              disabled={sending}
              data-testid="kontakt-submit"
              className="btn-primary w-full disabled:opacity-60"
            >
              {sending ? (
                <>
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  Wird gesendet…
                </>
              ) : (
                "Nachricht senden"
              )}
            </button>

            <p className="font-sans text-xs text-ink/60 text-center">
              Ihre Angaben werden nur zur Beantwortung Ihrer Anfrage verwendet. Details in unserer{" "}
              <a href="/datenschutz" className="underline hover:text-charcoal">Datenschutzerklärung</a>.
            </p>
          </form>
        </div>
      )}
    </LegalLayout>
  );
}
